import { Outlet, useParams } from "react-router-dom";

import { TabsWithRoute } from "@/components/TabsWithRoute";
import { ScrollableTabs } from "@/components/ScrollableTabs";
import { TabsContainer } from "../TabsContainer";

export function Preoperative() {
	const { attendanceId } = useParams();

	return (
		<>
			<TabsContainer>
				<ScrollableTabs>
					<TabsWithRoute
						name="Admissão de Enfermagem"
						route={`/atendimento/${attendanceId}/pre-operatorio/admissao-de-enfermagem`}
					/>

					<TabsWithRoute
						name="Admissão Médica"
						route={`/atendimento/${attendanceId}/pre-operatorio/admissao-medica`}
					/>

					<TabsWithRoute
						name="Consulta Pré-Anestésica"
						route={`/atendimento/${attendanceId}/pre-operatorio/consulta-pre-anestesica`}
					/>
				</ScrollableTabs>
			</TabsContainer>

			{/* portal */}
			<div id="preoperative-content">
				<Outlet />
			</div>
		</>
	);
}
